import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { Button } from "@design-system/Inputs/Button";
import { useTranslation } from "react-i18next";
import { keys, RESOURCE_NAME } from "./i18n";
import { type TableGroupingType } from "./types";
import { type FC } from "react";

type GroupingSelectProps = {
    value: TableGroupingType;
    onChange: (groupingType: TableGroupingType) => void;
};

export const GroupingSelect: FC<GroupingSelectProps> = ({
    value: groupingType,
    onChange,
}) => {
    const { t } = useTranslation(RESOURCE_NAME);

    const value = [groupingType];
    const handleValueChange = (value: string[]) => {
        if (value.length === 0) return;
        onChange(value[0] as TableGroupingType);
    };
    return (
        <Dropdown
            selectType="single"
            value={value}
            onValueChange={handleValueChange}
        >
            <Dropdown.Trigger asChild>
                <Button variant="textLink" size="sm">
                    <Button.Icon name="group" />
                    {t(keys[`group_filter_${groupingType}`])}
                    <Button.Icon name="chevronDown" />
                </Button>
            </Dropdown.Trigger>
            <Dropdown.Content hasPortal>
                <Dropdown.SelectableItem value="none">
                    <Dropdown.SelectedIndicator />
                    <Dropdown.ItemText>
                        {t(keys.group_filter_none)}
                    </Dropdown.ItemText>
                </Dropdown.SelectableItem>
                <Dropdown.SelectableItem value="subtheme">
                    <Dropdown.SelectedIndicator />
                    <Dropdown.ItemText>
                        {t(keys.group_filter_subtheme)}
                    </Dropdown.ItemText>
                </Dropdown.SelectableItem>
            </Dropdown.Content>
        </Dropdown>
    );
};
